import Paper from "@mui/material/Paper";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid2";
import CalculationTypesTable from "./CalculationTypesTable";
import CreateCalculationType from "./CreateCalculationType/CreateCalculationType";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserToken,
} from "../../../../features/userSlice";
import { CalculationTypesEndPointLogic } from "../../../../logic/DataCollection/Unifier/CalculationTypesEndpointLogic";
import { useDispatch } from "react-redux";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { setOpenModalType } from "../../../../features/unifierCalculationTypesSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

const tableHeadings = {
  id: "ID",
  name: "Name",
  custom_expression: "Description",
};

const CalculationTypes = () => {
  const { openModalType } = useSelector(
    (state: any) => state.unifierCalculationTypes
  );
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const response = useSelector(selectUserData);
  const hasUnifierCreateEditCalculationTypesPermission = CheckPermissions(
    response?.data?.products?.data_collection,
    "unifier",
    "create/edit_calculation_types"
  );

  const handleOpenModal = () => {
    dispatch(setOpenModalType("create"));
  };
  const handleCloseModal = () => {
    dispatch(setOpenModalType(""));
  };

  const fetchCalCulationTypes = async () => {
    try {
      await CalculationTypesEndPointLogic.getCollectionTypes(
        oauthTokenHeader,
        dispatch
      );
    } catch (error) {
      console.error("Error fetching Calculation Types: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!oauthTokenHeader) return;
    fetchCalCulationTypes();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Paper sx={{ mb: 1 }}>
        <Box sx={{ padding: "10px 16px 0px" }}>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Grid size={8}>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                Calculation Types
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                View, create and edit the calculation types used for extracting
                the correct term for unifying the data from raw tables to the
                destination tables.
              </Typography>
            </Grid>
            <Grid
              size={4}
              container
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="flex-end"
            >
              {hasUnifierCreateEditCalculationTypesPermission ? (
                <Button
                  data-tracker="375"
                  variant="contained"
                  color="secondary"
                  sx={{ whiteSpace: "nowrap" }}
                  onClick={handleOpenModal}
                >
                  Create new Type <AddIcon sx={{ width: "20px", ml: "5px" }} />
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ whiteSpace: "nowrap" }}
                  disabled
                >
                  Create new Type <AddIcon sx={{ width: "20px", ml: "5px" }} />
                </Button>
              )}
            </Grid>
          </Grid>
        </Box>
        {loading ? (
          <SimpleBackdrop />
        ) : (
          <>
            <CalculationTypesTable tableHeadings={tableHeadings} />
          </>
        )}
      </Paper>
      {openModalType === "create" && (
        <CreateCalculationType open={true} handleClose={handleCloseModal} />
      )}
    </>
  );
};

export default CalculationTypes;
